<template>
   <v-speed-dial :open-on-hover="showCommands" direction="left" transition="scale" v-bind="$attrs"
                 v-if="statusCommands" v-model="fab" v-on="$listeners">
      <template slot="activator">
         <v-tooltip bottom>
            <v-btn :color="fabColor" @click="onFabClick" fab v-bind="fabSettings" v-model="fab" slot="activator">
               <v-icon :style="{'font-size': fabIconSize}">{{fabIcon}}</v-icon>
               <v-icon v-if="showCommands">close</v-icon>
            </v-btn>
            {{fabHint}}
         </v-tooltip>
      </template>

      <v-tooltip :key="i" top v-for="(fab, i) in statusCommands" v-if="showCommands">
         <v-btn :color="fab.color" @click="$emit('onFabCommand', fab.cmd)" dark fab
                slot="activator" small style="z-index: 200;">
            <v-icon style="font-size: 21px">{{fab.icon}}</v-icon>
         </v-btn>
         {{fab.hint}}
      </v-tooltip>

   </v-speed-dial>
</template>

<script>
   export default {
      name: 'campaign-status-fab',

      props: ['statusCommands', 'statusIcon', 'fabColor', 'fabSettings'],

      data () {
         return {
            fab: false
         };
      },

      computed: {
         showCommands () {
            return this.statusCommands && this.statusCommands.length > 1;
         },

         fabIcon () {
            if (!this.showCommands) {
               if (this.statusCommands) {
                  return this.statusCommands[0].icon;
               }
            } else {
               return this.statusIcon || 'more_vert';
            }
         },

         fabHint () {
            if (!this.showCommands) {
               if (this.statusCommands) {
                  return this.statusCommands[0].hint;
               }
            } else {
               return 'Opções';
            }
         },

         fabIconSize () {
            if (this.fabSettings && this.fabSettings.small) {
               return '22px';
            }

            return '28px';
         }

      },

      methods: {
         onFabClick () {
            if (!this.showCommands) {
               this.$emit('onFabCommand', this.statusCommands[0].cmd);

            }
         }
      },

   };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/CampaignStatusFab.vue